import { Link } from "react-router";

import { PATHS } from "../routes/routes.constants.ts";
import { SHELL_COPY } from "./shell.constants.ts";
import type { PortalView } from "./shell.model.ts";

export function PortalHeader({
  title,
  subtitle,
  primaryAction,
  secondaryAction,
  canSwitch,
}: {
  title: string;
  subtitle: string;
  primaryAction: PortalView["primaryAction"];
  secondaryAction: PortalView["secondaryAction"];
  canSwitch: boolean;
}) {
  return (
    <header className="shell__header">
      <div className="shell__header-titles">
        <h1 className="shell__title">{title}</h1>
        {subtitle && <p className="shell__subtitle">{subtitle}</p>}
      </div>

      <div className="shell__header-actions">
        {canSwitch && (
          <Link to={PATHS.workspaces} className="shell__switch">
            {SHELL_COPY.switchWorkspace}
          </Link>
        )}
        {/* Null when the server says this caller may not act — not when the
            client decides a role should not. See PortalSpec.primaryAction. */}
        {secondaryAction && (
          <Link to={secondaryAction.href} className="shell__secondary">
            <span aria-hidden="true">+</span> {secondaryAction.label}
          </Link>
        )}
        {primaryAction && (
          <Link to={primaryAction.href} className="shell__primary">
            <span aria-hidden="true">✦</span> {primaryAction.label}
          </Link>
        )}
      </div>
    </header>
  );
}
